<template>
  <DataTable
    :value="platforms"
    :class="[
      platforms && platforms.length == 0 ? 'empty-table' : '',
      isActiveFirst ? 'active-first' : '',
    ]"
    class="scroll-table-y main-table scrollbar-custom"
    stripedRows
    @sort="sortTable"
    removableSort
    scrollable
    :loading="isLoading"
    dataKey="id"
    columnResizeMode="expand"
  >
    <Column field="number" header="№" style="min-width: 44px">
      <template #body="slotProps">
        {{ rowsCount + slotProps.index + 1 }}
      </template>
    </Column>
    <Column field="name" header="Название площадки" sortable>
      <template #body="slotProps">
        <RouterLink
          :to="{ name: 'platform', params: { id: slotProps.data.slug } }"
        >
          {{ slotProps.data.name }}
        </RouterLink>
      </template>
    </Column>
    <Column field="slug" header="Slug" sortable></Column>
    <Column field="is_platform" header="Платформа">
      <template #body="slotProps">
        <span v-if="slotProps.data.is_platform">Да</span>
        <span v-else>Нет</span>
      </template>
    </Column>
    <Column field="patterns" header="Паттерны" style="max-width: 150px">
      <template #body="slotProps">
        <ListWithTooltips
          :slotProps="slotProps.data.patterns"
          items="patterns"
          item-key="none"
          item-value="none"
        />
      </template>
    </Column>

    <Column field="cuser" header="Автор">
      <template #body="slotProps">
        {{ getUserFullName(slotProps.data.cuser) }}
      </template>
    </Column>

    <Column
      field="ctime"
      header="Дата создания"
      sortable
      style="min-width: 153px"
    >
      <template #body="slotProps">
        {{ convertDateFromUTC(slotProps.data.ctime) }}
      </template>
    </Column>
    <Column
      field="mtime"
      header="Дата обновления"
      sortable
      style="min-width: 173px; max-width: 173px"
    >
      <template #body="slotProps">
        {{ convertDateFromUTC(slotProps.data.mtime) }}
      </template>
    </Column>

    <Column frozen alignFrozen="right">
      <template #body="slotProps">
        <div
          @click="(event) => toggle(slotProps.data.slug, event)"
          aria-haspopup="true"
          aria-controls="overlay_menu"
          class="button-menu"
        >
          <span :data-segment="1" class="pi pi-ellipsis-v"></span>
        </div>
      </template>
    </Column>
  </DataTable>
  <Menu ref="menu" id="overlay_menu" :model="filteredItems" :popup="true" />
  <DeleteConfirmDialog
    deleted-name="рекламную площадку"
    :visible="confirmVisible.delete"
    :blocked="blockedButtonDelete"
    @close="confirmVisible.delete = false"
    @delete="deletePlatform"
  />
  <UsersHistoryDialog
    entity="sources"
    :object_id="modifiedId"
    :visible="confirmVisible.history"
    @close="confirmVisible.history = false"
  ></UsersHistoryDialog>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/store/auth/login";
import { usePlatformsStore } from "@/store/dictionaries/platforms";

import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Menu from "primevue/menu";
import UsersHistoryDialog from "@/widgets/dialogs/UsersHistoryDialog.vue";
import DeleteConfirmDialog from "@/shared/dialogs/DeleteConfirmDialog.vue";
import ListWithTooltips from "@/entities/segments/table/ListWithTooltips.vue";

import { convertDateFromUTC } from "@/services/utils/DateParser";
import { getUserFullName } from "@/services/utils/Names";
import { rootGetters } from "@/main";

defineProps<{
  platforms: any[];
  isActiveFirst: boolean;
  isLoading: boolean;
  rowsCount: number;
}>();
const emits = defineEmits(["sortTable", "updateTable"]);
const router = useRouter();
const store = usePlatformsStore();
const authStore = useAuthStore();

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(["history:edit"], ["history:read"]);
});

let modifiedId = ref("");
const confirmVisible = ref({
  history: false,
  delete: false,
});
const blockedButtonDelete = ref(false);
const menu = ref();
const items = ref([
  {
    label: "История действий",
    icon: "pi pi-history",
    checkDenied: true,
    archive: "both",
    command: () => {
      confirmVisible.value.history = true;
    },
  },
  {
    label: "Редактировать",
    icon: "pi pi-pencil",
    archive: "no_archive",
    command: () => {
      router.push({ name: "platform", params: { id: modifiedId.value } });
    },
  },
  {
    label: "Удалить",
    icon: "pi pi-trash",
    archive: "both",
    command: () => {
      confirmVisible.value.delete = true;
    },
  },
]);

const filteredItems = computed(() => {
  return items.value.filter((item) => !(item.checkDenied && isDenied.value));
});

const toggle = (elemId: string, event: any) => {
  modifiedId.value = elemId;
  menu.value.toggle(event);
};

const sortTable = (event: any) => {
  let orderField = "";
  if (event.sortField)
    orderField = event.sortOrder > 0 ? event.sortField : `-${event.sortField}`;
  emits("sortTable", orderField);
};

const deletePlatform = () => {
  blockedButtonDelete.value = true;
  store
    .deletePlatform(modifiedId.value)
    .finally(() => {
      emits("updateTable");
      blockedButtonDelete.value = false;
      confirmVisible.value.delete = false;
    })
    .catch((err: any) => {
      if (err.response && err.response.status == 400)
        rootGetters.toast.show("warn", "Ошибка", err.response.data.detail);
    });
};
</script>
